// Cart-drawer UI glue (breakdown/reco/promo toggles + discount-app sync) moved out of snippets/cart-drawer.liquid (static, no Liquid); loads after cart.js so window.updateCartDrawerGiftStrips is defined.

// Delegated so handlers survive cart drawer re-renders.
document.addEventListener('click', function (e) {
  // "Total to Pay" collapsible breakdown; state lives on the persistent <cart-drawer> so it survives cart-update re-renders (CSS keyed on .cd-breakdown-open shows it instantly, no flicker) like the reco/promo panels below.
  var toggle = e.target.closest('.cart-drawer__total-toggle');
  if (toggle) {
    var cdBd = toggle.closest('cart-drawer');
    if (cdBd) cdBd.classList.toggle('cd-breakdown-open');
    window.syncCartDrawerBreakdown && window.syncCartDrawerBreakdown();
    return;
  }

  // Desktop "You may also like" side panel tab; state lives on the persistent <cart-drawer> so it survives the drawer re-rendering on cart updates (otherwise it would re-open every update).
  var tab = e.target.closest('.cart-recos-side__tab') || e.target.closest('.cart-recos-back__button');
  if (tab) {
    var cd = tab.closest('cart-drawer');
    if (cd) {
      var open = cd.classList.toggle('reco-side-open');
      cd.querySelector('.cart-recos-side__tab')?.setAttribute('aria-expanded', String(open));
    }
    return;
  }

  // Mobile "You may also like" footer accordion; state lives on the persistent <cart-drawer> so it survives cart-update re-renders.
  var footBtn = e.target.closest('.cart-recos-foot__summary');
  if (footBtn) {
    var cdFoot = footBtn.closest('cart-drawer');
    if (cdFoot) {
      var footOpen = cdFoot.classList.toggle('reco-foot-open');
      footBtn.setAttribute('aria-expanded', String(footOpen));
    }
    return;
  }

  // "Have a promo code?" reveals the d-cart app UI; state lives on the persistent <cart-drawer> so it stays open across cart-update re-renders (like the 'You may also like' panels).
  var promo = e.target.closest('#cart-drawer-promo-trigger');
  if (promo) {
    var cdPromo = promo.closest('cart-drawer');
    if (cdPromo) cdPromo.classList.toggle('promo-open');
    window.syncCartDrawerPromo && window.syncCartDrawerPromo();
    return;
  }
});

// Apply the persisted breakdown state (aria/label/hidden) after re-renders; visibility + caret are CSS-driven via cart-drawer.cd-breakdown-open so content never flickers, and it's idempotent (writes only on change) so it can't loop the observer.
window.syncCartDrawerBreakdown = function () {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;
  var open = cd.classList.contains('cd-breakdown-open');
  var toggle = cd.querySelector('.cart-drawer__total-toggle');
  if (toggle && toggle.getAttribute('aria-expanded') !== String(open)) toggle.setAttribute('aria-expanded', String(open));
  var summary = cd.querySelector('.cart-drawer__summary');
  if (summary) summary.classList.toggle('is-open', open);
  var details = cd.querySelector('.cart-drawer__summary-details');
  if (details && details.hidden !== !open) details.hidden = !open;
  var label = cd.querySelector('.cart-drawer__total-label');
  if (label) {
    var txt = open
      ? (label.getAttribute('data-label-open') || 'Hide breakdown')
      : (label.getAttribute('data-label-closed') || 'View breakdown');
    if (label.textContent !== txt) label.textContent = txt;
  }
};

// Apply the persisted promo state to the trigger + the d-cart app form.
window.syncCartDrawerPromo = function () {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;
  var open = cd.classList.contains('promo-open');
  var trigger = document.getElementById('cart-drawer-promo-trigger');
  if (trigger) {
    trigger.setAttribute('aria-expanded', String(open));
    trigger.classList.toggle('is-open', open);
  }
  var app = document.querySelector('.sc_minimale-toggle');
  if (app && app.parentElement) {
    app.parentElement.classList.toggle('sc-minimal__form--show', open);
  }
  window.hideCartDrawerAutoDiscounts && window.hideCartDrawerAutoDiscounts();
};

// REVERTED to a no-op-style function: all coupon chips (automatic + manual) stay visible; it just clears any inline display:none, and call sites remain valid.
window.hideCartDrawerAutoDiscounts = function () {
  var tags = document.querySelectorAll('#CartDrawer .scDiscount .sc-tag');
  tags.forEach(function (tag) {
    tag.style.display = '';
  });
};

// A signature of the currently applied discount chips (auto + manual); when it changes, an order-level discount was applied/removed by the d-cart app.
function cartDrawerDiscountSig() {
  var codes = document.querySelectorAll('#CartDrawer .scDiscount .sc-tag .code');
  return Array.prototype.map.call(codes, function (c) { return (c.textContent || '').trim(); }).sort().join('|');
}

// The d-cart app applies order/cart-level discounts server-side without re-rendering the cart-drawer section, so re-fetch just the summary block via the Section Rendering API and swap it in, preserving the open/closed breakdown state.
window.refreshCartDrawerSummary = function () {
  var current = document.querySelector('#CartDrawer .cart-drawer__summary');
  if (!current) return;
  fetch(window.location.pathname + '?section_id=cart-drawer')
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__summary');
      var cur = document.querySelector('#CartDrawer .cart-drawer__summary');
      if (!fresh || !cur) return;
      cur.replaceWith(fresh);
      // Re-apply the open/closed state from the persistent cart-drawer.cd-breakdown-open class (single source of truth) so the swapped-in summary keeps the user's state.
      window.syncCartDrawerBreakdown && window.syncCartDrawerBreakdown();
    })
    .catch(function () {});
};

// Re-apply promo state after the drawer re-renders and whenever the d-cart app injects/updates its chips (cart updates replace #CartDrawer); all coupon chips (automatic + manual) are shown, see hideCartDrawerAutoDiscounts above.
var cdEl = document.getElementById('CartDrawer');
if (cdEl && 'MutationObserver' in window) {
  var promoSyncTimer;
  new MutationObserver(function () {
    // Re-apply persisted breakdown + promo state IMMEDIATELY (cheap, idempotent) so the promo form doesn't flash collapsed then re-open on a cart update; they only touch class/aria state so they can't loop this observer.
    window.syncCartDrawerBreakdown && window.syncCartDrawerBreakdown();
    window.syncCartDrawerPromo && window.syncCartDrawerPromo();

    // The expensive work (discount signature + totals re-fetch) stays debounced.
    clearTimeout(promoSyncTimer);
    promoSyncTimer = setTimeout(function () {
      window.hideCartDrawerAutoDiscounts && window.hideCartDrawerAutoDiscounts();
      // Refresh totals only when the set of applied discounts actually changed (swapping the summary doesn't touch the chips, so this can't loop).
      var sig = cartDrawerDiscountSig();
      if (sig !== window.__cartDrawerDiscountSig) {
        window.__cartDrawerDiscountSig = sig;
        window.refreshCartDrawerSummary();
      }
    }, 80);
  }).observe(cdEl, { childList: true, subtree: true });
}
window.__cartDrawerDiscountSig = cartDrawerDiscountSig();
window.syncCartDrawerBreakdown && window.syncCartDrawerBreakdown();
window.hideCartDrawerAutoDiscounts();
window.updateCartDrawerGiftStrips && window.updateCartDrawerGiftStrips();

// Klaviyo Back-in-Stock targets the FIRST /cart/add form on the page, which on sold-out products is a drawer "You may also like" card: it injects its notify button (hidden in base.css) and hides that card's "Add" button. Undo the hiding on the reco card only; the container is left in place so Klaviyo doesn't re-inject.
(function () {
  function restoreRecoAddButton() {
    var bis = document.querySelector('#CartDrawer #klaviyo-bis-button-container');
    var card = bis && bis.closest('.cart-reco');
    if (!card) return;
    card.querySelectorAll('.cart-reco__add').forEach(function (btn) {
      if (btn.style.display) btn.style.removeProperty('display');
      if (btn.hidden) btn.hidden = false;
    });
  }
  restoreRecoAddButton();
  new MutationObserver(restoreRecoAddButton).observe(document.body, { childList: true, subtree: true });
})();
